import { getCdnURL } from '@/domains/care/helpers';
import { httpClient } from '@/domains/core/httpClient/httpClient';
import { getAppSetting } from '@/domains/core/settings/appSettings';
import { PLATFORM } from '@/domains/core/settings/constants';
import type { RhinoProduct } from '@/domains/productDiscovery/ProductPage/interfaces/RhinoProduct';
import {
  processRhinoBrand,
  processRhinoPrice,
  processRhinoRating,
} from '@/domains/productDiscovery/SponsoredProductRecommendation/services/rhino/processor.default';

export const fetchMDRankingRhinoProducts = async (
  articleIds: number[],
): Promise<RhinoProduct[]> => {
  const articlesData: RhinoProduct[] = await httpClient
    .get(`/api/product-discovery/product-cards`, {
      baseURL: getAppSetting('MS_API_URL'),
      headers: { 'x-platform': PLATFORM.toUpperCase() },
      params: {
        article_ids: articleIds.join(','),
        with_sku_count: true,
        with_catalog_attributes: true,
        with_delivery_detail: true,
        with_delivery_options: true,
        is_pro: false,
      },
    })
    .then((res) =>
      res.data?.content.map((rhinoProduct: any) => ({
        productId: Number(rhinoProduct.offer.product_id),
        articleId: Number(rhinoProduct.master_product.article_id),
        modelId: Number(rhinoProduct.sku.model_id),
        title: rhinoProduct.sku.title,
        brand: processRhinoBrand(rhinoProduct.master_product.brand),
        price: processRhinoPrice(rhinoProduct.offer.price),
        imagePath: `${getCdnURL()}${rhinoProduct.sku.media[0].thumbnail_url}`,
        rating: processRhinoRating(rhinoProduct.sku.rating),
        productSlug: rhinoProduct.sku.slug_article,
        isIndexable: rhinoProduct.master_product.is_indexable,
        modelsCount: rhinoProduct?.master_product?.sku_count || 0,
        isTopSales: rhinoProduct?.offer?.is_top_sale || false,
        isProProduct: rhinoProduct?.offer?.is_pro_product || false,
        isFulfillment: rhinoProduct?.offer?.is_fulfillment || false,
      })),
    );

  return articlesData.sort(
    (a, b) => articleIds.indexOf(a.articleId) - articleIds.indexOf(b.articleId),
  );
};
